import React from 'react';
import { Sidebar as ProSidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Box, useTheme } from '@mui/material';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { tokens } from 'theme';

import { useSidebarStatus } from './hooks';
import { getContainerStyle } from './helpers';
import { SideBarItems } from './components/sidebar-items';

export const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { isSidebarOpen, toggleSidebar } = useSidebarStatus();

  return (
    <Box sx={getContainerStyle(colors.primary[400])}>
      <ProSidebar collapsed={!isSidebarOpen} style={{ height: '100%' }}>
        <Menu data-testid={'ps-sidebar-container-test-id'}>
          <MenuItem
            data-testid={'ps-sidebar-toggle-icon'}
            onClick={toggleSidebar}
            icon={<MenuOutlinedIcon />}
            style={{
              margin: '10px 0 20px 0',
              color: colors.grey[100],
            }}
          />
          <SideBarItems />
        </Menu>
      </ProSidebar>
    </Box>
  );
};
